"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _radioModule = _interopRequireDefault(require("./radio.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcRadio(props) {
  var direction = props.direction ? props.direction : "horizontal";
  var display = props.displayKey ? props.displayKey : 'label';
  var key = props.id ? props.id : display;
  var radiogroupName = props.radiogroupName ? props.radiogroupName : 'radiogroupName';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _radioModule["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement(_lib.Radio.Group, {
    name: radiogroupName,
    className: _radioModule["default"][direction],
    defaultValue: props === null || props === void 0 ? void 0 : props.defaultChecked,
    onChange: props.onChange,
    disabled: props === null || props === void 0 ? void 0 : props.disabled,
    value: props === null || props === void 0 ? void 0 : props.value
  }, props.options.map(function (items) {
    return /*#__PURE__*/_react["default"].createElement(_lib.Radio, {
      value: items.value
    }, items[display]);
  })));
}
var _default = ArcRadio;
exports["default"] = _default;